import React from 'react';
import Plot from 'react-plotly.js';
import { HelpText } from '../UsageStatistic/UsageStatistic.styles';
import { themeDefault } from '../../styles/themes/theme.default';
import { GREEN_THRESHOLD, YELLOW_THRESHOLD } from '../../_constants';
import { ChartsContainer } from '../CanopyDetection/CanopyDetection.styles';

const getValueColor = (value, target) => {
  if (value < target * GREEN_THRESHOLD) return themeDefault.colors.gauge.greenLine;
  if (value < target * YELLOW_THRESHOLD) return themeDefault.colors.gauge.yellowLine;
  return themeDefault.colors.gauge.redLine;
};
const GaugeChart = ({ data }) => (
  <ChartsContainer>
    <Plot
      data={[
        {
          type: 'indicator',
          mode: 'gauge+number',
          value: data.used,
          number: {
            suffix: '',
            font: { size: 36, color: getValueColor(data.used, data.month_area) },
            valueformat: '.0f'
          },
          gauge: {
            axis: {
              range: [0, data.month_area],
              visible: false
            },
            bar: {
              color: getValueColor(data.area, data.month_area),
              thickness: 0.5
            },
            bgcolor: 'transparent',
            borderwidth: 0,
            steps: [
              {
                range: [0, data.month_area * GREEN_THRESHOLD],
                color: themeDefault.colors.gauge.greenBackground
              },
              {
                range: [
                  data.month_area * GREEN_THRESHOLD,
                  data.month_area * YELLOW_THRESHOLD
                ],
                color: themeDefault.colors.gauge.yellowBackground
              },
              {
                range: [data.month_area * YELLOW_THRESHOLD, data.month_area],
                color: themeDefault.colors.gauge.redBackground
              }
            ]
          }
        }
      ]}
      layout={{
        width: 200,
        height: 100,
        margin: { t: 0, b: 0, l: 0, r: 0 },
        font: { color: themeDefault.colors.gauge.redBackground, family: 'Arial' }
      }}
      config={{ displayModeBar: false }}
    />
    <HelpText>
      {data.pipeline}
      {', m²'}
    </HelpText>
  </ChartsContainer>
);

export default GaugeChart;
